module.exports = __webpack_public_path__ + "static/media/menu-close.d8fbea5b.svg";